// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-sidebar-mask {
	top: 65px !important;
	align-items: start !important;
	max-height: calc(100% - 65px) !important;
}

.QG69o5nECn0A1lqZ {
	background-color: #F3F5F7;
	border-radius: 0 26px 26px 0;
	padding: 0 0 0 26px;
	max-height: calc(100vh - 65px) !important;
}

.QG69o5nECn0A1lqZ h2 {
	font-family: Roboto;
	font-size: 20px;
	font-weight: 700;
	color: #303030;
	margin-bottom: 45px;
}

.QG69o5nECn0A1lqZ i::before {
	display: inline-block;
	height: 25px;
	width: 25px;
	font-size: 16px;
	margin-top: 8px;
}

.QG69o5nECn0A1lqZ i {
	margin-right: 12px;
}

.QG69o5nECn0A1lqZ li {
	margin-right: 25px;
}

.QG69o5nECn0A1lqZ li a {
	background-color: #ffffff;
	border-radius: 16px;
	font-family: Roboto;
	font-size: 16px;
	font-weight: 600;
	color: #303030;
	padding: 15px;
	margin-bottom: 18px;
}

.QG69o5nECn0A1lqZ li a:hover {
	background-color: #e1e7ed;
}

li.IItcHrZIgSY4QWQk {
	margin-right: 0;
}

.QG69o5nECn0A1lqZ li a.IItcHrZIgSY4QWQk {
	border-radius: 16px 0 0 16px;
	color: #ffffff;
	background-color: #20336c;
}

a.IItcHrZIgSY4QWQk i {
	margin-right: 30px;
}

.d0_cvWthPk1K9vQp {
	border-radius: 16px;
	width: 70%;
	font-size: 14px;
	margin-top: 35px;
	align-items: center;
	justify-content: center;
	margin-left: 12%;
}

.d0_cvWthPk1K9vQp span {
	margin-right: 14px;
}

.QbwqRVB3IwIUiUey {
	width: 100%;
	background-color: #4D87BE;
	border-radius: 16px;
	padding: 18px 20px;
	font-size: 20px;
	font-weight: 600;
	color: #ffffff;
	border: none;
}

.QbwqRVB3IwIUiUey:hover {
	background-color: #20336C;
}

.slIP_XGz2kwbiJTX {
	width: 100%;
	background-color: #F3F5F7;
	border-radius: 16px;
	padding: 10px 20px;
	color: #4D87BE;
	font-size: 20px;
	font-weight: 600;
	border: none;
}

.slIP_XGz2kwbiJTX:hover {
	color: #305375;
}

.zceMy7BeciczTPb_ {
	width: 541px !important;
	height: 354px !important;
	background-color: #F3F5F7;
	border-radius: 25px !important;
}

.zceMy7BeciczTPb_ .p-dialog {
	border-radius: 25px !important;
	background-color: #F3F5F7;
}

.zceMy7BeciczTPb_ .p-dialog-footer {
	border-bottom-right-radius: 25px !important;
	border-bottom-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.zceMy7BeciczTPb_ .p-dialog-header {
	border-top-right-radius: 25px !important;
	border-top-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.zceMy7BeciczTPb_ .p-dialog-content{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.zceMy7BeciczTPb_ .rg8IU6b1f8QHqhud {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 20px;
	font-weight: 400;
}

.zceMy7BeciczTPb_ .p-dialog-content {
	background-color: #F3F5F7;
}

.zceMy7BeciczTPb_ .p-dialog-title {
	font-size: 1.875rem !important;
	font-weight: 700 !important;
}

@media screen and (max-width: 768px) {
	.p-sidebar-mask {
		top: 70px !important;
		align-items: start !important;
		max-height: calc(100% - 70px) !important;
	}
	
	.QG69o5nECn0A1lqZ {
		background-color: #F3F5F7;
		border-radius: 0 26px 26px 0;
		padding: 0 0 0 26px;
		max-height: calc(100vh - 70px) !important;
	}
}

@media screen and (max-width: 425px) {
	.zceMy7BeciczTPb_ {
		width: 350px !important;
	}
	
	.zceMy7BeciczTPb_ .p-dialog-title{
		font-size: 20px !important;
		font-weight: 700 !important;
	}
	
	.zceMy7BeciczTPb_ .rg8IU6b1f8QHqhud {
		font-size: 16px;
	}
	
	.kDh1SJOSOis_Iq1g {
		border-radius: 8px;
		padding: 14px 16px;
		font-size: 16px;
	}
	
	.slIP_XGz2kwbiJTX {
		border-radius: 8px;
		padding: 10px 20px;
		font-size: 16px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/MobileSidebar.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,6BAA6B;CAC7B,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,mBAAmB;CACnB,yCAAyC;AAC1C;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC;EACC,oBAAoB;EACpB,6BAA6B;EAC7B,wCAAwC;CACzC;;CAEA;EACC,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,yCAAyC;CAC1C;AACD;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,0BAA0B;EAC1B,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;CAChB;AACD","sourcesContent":[":global(.p-sidebar-mask) {\r\n\ttop: 65px !important;\r\n\talign-items: start !important;\r\n\tmax-height: calc(100% - 65px) !important;\r\n}\r\n\r\n.sidebar {\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 0 26px 26px 0;\r\n\tpadding: 0 0 0 26px;\r\n\tmax-height: calc(100vh - 65px) !important;\r\n}\r\n\r\n.sidebar h2 {\r\n\tfont-family: Roboto;\r\n\tfont-size: 20px;\r\n\tfont-weight: 700;\r\n\tcolor: #303030;\r\n\tmargin-bottom: 45px;\r\n}\r\n\r\n.sidebar i::before {\r\n\tdisplay: inline-block;\r\n\theight: 25px;\r\n\twidth: 25px;\r\n\tfont-size: 16px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n.sidebar i {\r\n\tmargin-right: 12px;\r\n}\r\n\r\n.sidebar li {\r\n\tmargin-right: 25px;\r\n}\r\n\r\n.sidebar li a {\r\n\tbackground-color: #ffffff;\r\n\tborder-radius: 16px;\r\n\tfont-family: Roboto;\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tcolor: #303030;\r\n\tpadding: 15px;\r\n\tmargin-bottom: 18px;\r\n}\r\n\r\n.sidebar li a:hover {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\nli.active {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.sidebar li a.active {\r\n\tborder-radius: 16px 0 0 16px;\r\n\tcolor: #ffffff;\r\n\tbackground-color: #20336c;\r\n}\r\n\r\na.active i {\r\n\tmargin-right: 30px;\r\n}\r\n\r\n.logoutBtn {\r\n\tborder-radius: 16px;\r\n\twidth: 70%;\r\n\tfont-size: 14px;\r\n\tmargin-top: 35px;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tmargin-left: 12%;\r\n}\r\n\r\n.logoutBtn span {\r\n\tmargin-right: 14px;\r\n}\r\n\r\n.confirmDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #4D87BE;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 20px;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n}\r\n\r\n.confirmDialogBtn:hover {\r\n\tbackground-color: #20336C;\r\n}\r\n\r\n.cancelDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px;\r\n\tpadding: 10px 20px;\r\n\tcolor: #4D87BE;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tborder: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n\tcolor: #305375;\r\n}\r\n\r\n.alertModal {\r\n\twidth: 541px !important;\r\n\theight: 354px !important;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 25px !important;\r\n}\r\n\r\n.alertModal :global(.p-dialog) {\r\n\tborder-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 25px !important;\r\n\tborder-bottom-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 25px !important;\r\n\tborder-top-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content){\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex-direction: column;\r\n}\r\n\r\n.alertModal .text {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-align: center;\r\n\tfont-size: 20px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-title) {\r\n\tfont-size: 1.875rem !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t:global(.p-sidebar-mask) {\r\n\t\ttop: 70px !important;\r\n\t\talign-items: start !important;\r\n\t\tmax-height: calc(100% - 70px) !important;\r\n\t}\r\n\t\r\n\t.sidebar {\r\n\t\tbackground-color: #F3F5F7;\r\n\t\tborder-radius: 0 26px 26px 0;\r\n\t\tpadding: 0 0 0 26px;\r\n\t\tmax-height: calc(100vh - 70px) !important;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n\t.alertModal {\r\n\t\twidth: 350px !important;\r\n\t}\r\n\t\r\n\t.alertModal :global(.p-dialog-title){\r\n\t\tfont-size: 20px !important;\r\n\t\tfont-weight: 700 !important;\r\n\t}\r\n\t\r\n\t.alertModal .text {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t\r\n\t.alertDialogBtn {\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 14px 16px;\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t\r\n\t.cancelDialogBtn {\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 10px 20px;\r\n\t\tfont-size: 16px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export var sidebar = `QG69o5nECn0A1lqZ`;
export var active = `IItcHrZIgSY4QWQk`;
export var logoutBtn = `d0_cvWthPk1K9vQp`;
export var confirmDialogBtn = `QbwqRVB3IwIUiUey`;
export var cancelDialogBtn = `slIP_XGz2kwbiJTX`;
export var alertModal = `zceMy7BeciczTPb_`;
export var text = `rg8IU6b1f8QHqhud`;
export var alertDialogBtn = `kDh1SJOSOis_Iq1g`;
export default ___CSS_LOADER_EXPORT___;
